import { buttonClasses } from '@/mixins/content'

export default {
  mixins: [buttonClasses],

  computed: {
    /**
     * Re-format the nested buttons so we can grab them by ID.
     *
     * Assumes you have a buttonData property in the parent component
     * that defines an Array of Objects that contain buttons. Fallsback
     * to generic `page`.
     */
    buttons() {
      const data = this.buttonData || [this.page]

      return data.reduce((all, item) => {
        if (!item?.buttons) {
          return all
        }

        // Grab the current nested buttons
        const current = [...item.buttons].reduce((buttons, btn) => {
          const classes = this.buttonClasses(btn)

          buttons[btn.id] = { ...btn, classes }

          return buttons
        }, {})

        // Merge them in and return
        return { ...all, ...current }
      }, {})
    },
  },
}
